import { Line } from '@react-three/drei';
import { type Size } from '@react-three/fiber';
import React from 'react';
import { normalizePoint } from '@/components/property-selector/utils';
import { type Point } from '@/types';

type ActiveShapeProps = {
  points: Point[];
  nextPoint?: Point | null;
  size: Size;
  color: string | number;
};

export function DrawActiveShapeLines({
  points,
  nextPoint,
  size,
  color = 0x0000ff,
}: ActiveShapeProps) {
  return points.map((point, index) => {
    const next = points[index + 1] ?? nextPoint;
    if (!next) return null;
    const normalizedPoint = normalizePoint(point, size);
    const normalizedNext = normalizePoint(next, size);
    return (
      <Line
        key={`line-${index}`}
        points={[
          [normalizedPoint.x, normalizedPoint.y, 1],
          [normalizedNext.x, normalizedNext.y, 1],
        ]}
        color={color}
        lineWidth={2}
      />
    );
  });
}
